import React from 'react';
import logo from '../../../assets/images/logo.svg';
import styles from './Logo.module.scss';
import cn from 'classnames';

interface LogoProps {
  className?: string;
}
function Logo({ className }: LogoProps) {
  return (
    <a href={'https://www.webfolio.com'} target={'_blank'} className={cn(styles.logo, className)} rel='noreferrer'>
      <img src={logo} alt={''} />
    </a>
  );
}

export default Logo;
